<span *transloco="let t; read: 'shared'" class="content" matSnackBarLabel>
  @if (data.title) {
    <span class="title">{{ t(data.title) }}</span>
  }
  @for (message of data.messages; track message) {
    <span class="message">{{ t(message.key, message?.params) }}</span>
  }
</span>

@if (data.actionLabel) {
  <span class="action" matSnackBarActions>
    <button mat-button matSnackBarAction color="primary" (click)="onAction()">{{ data.actionLabel }}</button>
  </span>
}
